import React from 'react';

export function MeetupInfoCard({
  squadDetails,
  isHost,
  meetupPoint,
  setMeetupPoint,
  meetupTime,
  setMeetupTime,
  notes,
  setNotes,
  isSaving,
  saveMessage,
  onSave,
}) {
  return (
    <div className="mb-6 rounded-lg bg-gray-900 border border-gray-800 p-6">
      <div className="mb-4 flex items-center justify-between border-b border-gray-800 pb-4">
        <h3 className="text-xl font-bold text-white">Pinned Meet-up Info</h3>
        {squadDetails.host_name && !isHost && (
          <span className="text-sm text-gray-400">Captain: {squadDetails.host_name}</span>
        )}
        {isHost && (
          <span className="rounded-full bg-[#4ADE80] px-3 py-1 text-xs font-semibold text-[#050505]">
            You are the Captain
          </span>
        )}
      </div>

      {/* Meet-up Point */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-semibold text-gray-300">
          📍 Meet-up Point
        </label>
        {isHost ? (
          <input
            type="text"
            value={meetupPoint}
            onChange={(e) => setMeetupPoint(e.target.value)}
            placeholder="Enter meet-up location"
            className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-white placeholder-gray-500 focus:border-[#4ADE80] focus:outline-none focus:ring-2 focus:ring-[#4ADE80]"
          />
        ) : (
          <div className="rounded-lg border border-gray-700 bg-gray-800 px-4 py-3 text-gray-300">
            {squadDetails.meetup_point || 'Not set yet.'}
          </div>
        )}
      </div>

      {/* Meet-up Time */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-semibold text-gray-300">
          ⏰ Meet-up Time
        </label>
        {isHost ? (
          <input
            type="datetime-local"
            value={meetupTime}
            onChange={(e) => setMeetupTime(e.target.value)}
            className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-white focus:border-[#4ADE80] focus:outline-none focus:ring-2 focus:ring-[#4ADE80]"
          />
        ) : (
          <div className="rounded-lg border border-gray-700 bg-gray-800 px-4 py-3 text-gray-300">
            {squadDetails.meetup_time 
              ? new Date(squadDetails.meetup_time).toLocaleString('en-GB', {
                  dateStyle: 'long',
                  timeStyle: 'short',
                })
              : 'Not set yet.'}
          </div>
        )}
      </div>

      {/* Notes */}
      <div className="mb-4">
        <label className="mb-2 block text-sm font-semibold text-gray-300">
          📝 Notes
        </label>
        {isHost ? (
          <textarea
            rows={4}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter notes for squad members"
            className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-white placeholder-gray-500 focus:border-[#4ADE80] focus:outline-none focus:ring-2 focus:ring-[#4ADE80]"
          />
        ) : (
          <div className="rounded-lg border border-gray-700 bg-gray-800 px-4 py-3 text-gray-300 whitespace-pre-wrap min-h-[100px]">
            {squadDetails.notes || 'Not set yet.'}
          </div>
        )}
      </div>

      {/* Save Button (only shown when user is captain) */}
      {isHost && (
        <div className="mt-4">
          {saveMessage && (
            <div className={`mb-3 rounded-lg p-3 ${
              saveMessage.type === 'success' 
                ? 'bg-green-900/20 border border-green-800/50 text-green-200' 
                : 'bg-red-900/20 border border-red-800/50 text-red-200'
            }`}>
              {saveMessage.text}
            </div>
          )}
          <button
            onClick={onSave}
            disabled={isSaving}
            className="w-full rounded-lg bg-[#4ADE80] px-6 py-3 font-semibold text-[#050505] transition-colors hover:bg-[#3bc96a] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      )}
    </div>
  );
}
